import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose Tailwind class names with conflict resolution.
 * Used by every component to merge variant classes with consumer overrides.
 *
 * @param {...(string | object | boolean | undefined | null)} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
